import { Card, CardContent, CardHeader, Tab, Tabs, Tooltip } from '@airbus/components-react';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import styles from './ApplicationList.module.css';

export function ApplicationList() {
  return (
    <section className={styles.baseContainer}>
      <Tabs aria-label='application list' floating value={0}>
        <Tab>Applications</Tab>
      </Tabs>
      <div className={styles.applicationListContainer}>{getApplicationList()}</div>
    </section>
  );
}

function getApplicationList() {
  const applications = [
    {
      id: 1,
      name: 'NPI',
      description: 'New Parts Industrialization',
      path: '/npi',
    },
    {
      id: 2,
      name: 'Procurement',
      description: 'Procurement App',
      path: '/procurement',
    },
  ];

  return applications.map((app) => {
    return (
      <div className={styles.applicationCard} key={app.id}>
        <Tooltip label={app.description} placement='bottom'>
          <Card onClick={() => (window.location.href = app.path)}>
            <CardHeader icon={<AirplanemodeActiveIcon />} title={app.name} />
            <CardContent></CardContent>
          </Card>
        </Tooltip>
      </div>
    );
  });
}
